var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{attrs:{"href":_vm.url}},[_vm._v(_vm._s(_vm.url))]),_c('CRow',{attrs:{"id":"iframe"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }